import { MutationTree } from 'vuex'
import {AuthInitState} from '@/store/auth/auth.types';

export const AuthenMutations: MutationTree<AuthInitState> = {
  ['authInit'](state) {
    // state.loading = true
  },
};
